import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Icon,
  IconButton,
  Spinner,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import download from 'downloadjs';
import { FiSearch } from 'react-icons/fi';
import { useHistory, useLocation } from 'react-router-dom';
import {
  FaCloudUploadAlt,
  FaEdit,
  FaEye,
  FaFileDownload,
} from 'react-icons/all';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import {
  Datepicker,
  Heading,
  Input,
  Pagination,
  Select,
  StatusBadge,
  Table,
} from '~/components';
import { AnnouncementsStatus } from '~/types/announcements';
import { ConfirmationDialog } from '~/components/ConfirmationDialog';
import { usePrivacyPolicy } from '~/hooks/usePrivacyPolicy';
import {
  downloadFile,
  existPrivacyPolicyDraft,
  publishPrivacyPolicy,
} from '~/services/PrivacyPolicy';
import { formatDate, parseDate } from '~/utils/formatDate';
import { PAGE_SIZE } from '~/constants';
import { useQueryParams } from '~/hooks';
import { updateUrlParams } from '~/utils/updateUrlParams';
import { queryClient } from '~/utils/react-query';

export const PrivacyPolicy: React.VFC = () => {
  const queryParams = useQueryParams();
  const location = useLocation();
  const history = useHistory();

  const limpavel = true;

  const toast = useToast();
  const {
    isOpen: isOpenModalPublicar,
    onOpen: onOpenModalPublicar,
    onClose: onCloseModalPublicar,
  } = useDisclosure();

  const [idSelecionado, setIdSelecionado] = useState<number>();
  const [isFetching, setIsFetching] = useState(false);
  const [isLoadingDownload, setIsLoadingDownload] = useState(false);
  const [parametros, setParametros] = useState(() => {
    const dataInicio = queryParams.get('dataInicial');
    const dataFim = queryParams.get('dataFinal');

    const parsedDataInicio = dataInicio
      ? parseDate(dataInicio, 'yyyy-MM-dd')
      : undefined;

    const parsedDataFim = dataFim
      ? parseDate(dataFim, 'yyyy-MM-dd')
      : undefined;

    return {
      busca: queryParams.get('busca') ?? '',
      situacao: queryParams.get('situacao') ?? '',
      dataInicial: parsedDataInicio ? parsedDataInicio.toISOString() : '',
      dataFinal: parsedDataFim ? parsedDataFim.toISOString() : '',
      pagina: queryParams.get('pagina') ?? '1',
      paginacao: queryParams.get('paginacao') ?? PAGE_SIZE.toString(),
      order: queryParams.get('order') ?? 'DESC',
      orderBy: queryParams.get('orderBy') ?? 'data_publicacao',
    };
  });
  const situacao = [
    { value: '', label: 'Todos' },
    { value: '0', label: 'Rascunho' },
    { value: '1', label: 'Publicado' },
    { value: '2', label: 'Cancelado' },
  ];
  const { data, isLoading, refetch } = usePrivacyPolicy(
    Number(parametros.pagina),
    parametros.busca,
    parametros.situacao,
    parametros.dataInicial,
    parametros.dataFinal,
    Number(parametros.paginacao),
    parametros.order,
    parametros.orderBy,
  );

  useEffect(() => {
    const pagina = queryParams.get('pagina');
    const dataInicial = queryParams.get('dataInicial');
    const dataFinal = queryParams.get('dataFinal');

    setParametros({
      ...parametros,
      pagina: pagina ?? '1',
    });
    updateUrlParams(
      {
        ...parametros,
        pagina: pagina ?? '1',
        dataInicial: dataInicial ?? '',
        dataFinal: dataFinal ?? '',
      },
      history,
    );
  }, [location.search]);

  const handleDataInicial = (e?: Date) => {
    const dataFinal = queryParams.get('dataFinal');

    const formatedDate = e ? e.toISOString().split('T')[0] : '';

    setParametros({
      ...parametros,
      pagina: '1',
      dataInicial: e ? e.toISOString() : '',
    });
    updateUrlParams(
      {
        ...parametros,
        pagina: '1',
        dataInicial: formatedDate,
        dataFinal: dataFinal ?? '',
      },
      history,
    );
  };

  const handleDataFinal = (e?: Date) => {
    const dataInicial = queryParams.get('dataInicial');

    const formatedDate = e ? e.toISOString().split('T')[0] : '';

    setParametros({
      ...parametros,
      pagina: '1',
      dataFinal: e ? e.toISOString() : '',
    });
    updateUrlParams(
      {
        ...parametros,
        pagina: '1',
        dataFinal: formatedDate,
        dataInicial: dataInicial ?? '',
      },
      history,
    );
  };

  const handlePageSizeChange = (e: any) => {
    const dataInicial = queryParams.get('dataInicial');
    const dataFinal = queryParams.get('dataFinal');
    setParametros({
      ...parametros,
      paginacao: e.target.value,
      pagina: '1',
    });
    updateUrlParams(
      {
        ...parametros,
        paginacao: e.target.value,
        pagina: '1',
        dataInicial: dataInicial ?? '',
        dataFinal: dataFinal ?? '',
      },
      history,
    );
  };

  const novoPolitica = () => {
    existPrivacyPolicyDraft().then(response => {
      if (response) {
        toast({
          title:
            "Não é permitido criar ou publicar um novo termo de uso que já exista com a situação 'Rascunho'.",
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        return;
      }
      history.push('/portal/admin/privacy-policy/new-privacy-policy/');
    });
  };

  const editarPolitica = (id: number) => {
    history.push(`/portal/admin/privacy-policy/new-privacy-policy/${id}/edit`);
  };
  const visualizarPolitica = (id: number) => {
    history.push(`/portal/admin/privacy-policy/${id}`);
  };

  const relatorioPolitica = (id: number) => {
    setIsLoadingDownload(true);
    downloadFile(id)
      .then(r => {
        if (r.data.size > 0) {
          download(
            new Blob([r.data], { type: r.data.type }),
            r.headers['content-disposition'].match(/filename="(.+)"/)[1],
          );
        } else {
          toast({
            title: r?.data?.error,
            description: 'Entre em contato para mais informações',
            status: 'error',
            duration: 3000,
            isClosable: true,
            position: 'top-right',
          });
        }
        setIsLoadingDownload(false);
      })
      .catch(err => {
        toast({
          title: `Erro`,
          description: err.message,
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        setIsLoadingDownload(false);
      });
  };

  const publicarPolitica = (id: number) => {
    setIsFetching(true);
    publishPrivacyPolicy(id)
      .then(() => {
        refetch();
        toast({
          title: 'Termos de uso publicados com sucesso',
          status: 'success',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
        queryClient.invalidateQueries('privacypolicy');
        onCloseModalPublicar();
      })
      .catch(() => {
        toast({
          title: 'Erro ao publicar termos de uso',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      })
      .finally(() => setIsFetching(false));
  };

  return (
    <Box px="8" py="4">
      <HStack gridGap={3}>
        <Heading>Termos de Uso</Heading>
        {isLoading && <Spinner />}
      </HStack>
      <HStack py={8} justifyContent="space-between" alignItems="flex-end">
        <HStack alignItems="flex-end" gridGap={3} w="65%">
          <Input
            name="search"
            type="text"
            icon={FiSearch}
            value={parametros.busca}
            onChange={e => {
              const dataInicial = queryParams.get('dataInicial');
              const dataFinal = queryParams.get('dataFinal');
              setParametros({
                ...parametros,
                pagina: '1',
                busca: e.target.value,
              });
              updateUrlParams(
                {
                  ...parametros,
                  pagina: '1',
                  busca: e.target.value,
                  dataInicial: dataInicial ?? '',
                  dataFinal: dataFinal ?? '',
                },
                history,
              );
            }}
            placeholder="Procure pela descrição"
            fontSize="15px"
            label=""
          />
          <Select
            name="situacao"
            fontSize="15px"
            label="Situação"
            isDisabled={isFetching}
            onChange={e => {
              const dataInicial = queryParams.get('dataInicial');
              const dataFinal = queryParams.get('dataFinal');
              setParametros({
                ...parametros,
                pagina: '1',
                situacao: e.target.value,
              });
              updateUrlParams(
                {
                  ...parametros,
                  pagina: '1',
                  situacao: e.target.value,
                  dataInicial: dataInicial ?? '',
                  dataFinal: dataFinal ?? '',
                },
                history,
              );
            }}
          >
            {situacao?.map(s => (
              <option key={s.value} value={s.value}>
                {s.label}
              </option>
            ))}
          </Select>
          <FormControl>
            <FormLabel style={{ fontSize: '14px' }}>
              Selecione o período de publicação
            </FormLabel>
            <HStack>
              <Datepicker
                onChange={handleDataInicial}
                isClearable={limpavel}
                selectedDate={
                  parametros.dataInicial.length > 0
                    ? new Date(parametros.dataInicial)
                    : undefined
                }
                placeholderText="Data inicial"
                dateFormat="dd/MM/yyyy"
                onBlur={event => {
                  const date = formatDate(event.target.value);
                  if (date) {
                    handleDataInicial(parseDate(date, 'dd/MM/yyyy'));
                  }
                }}
              />
              <Text>a</Text>
              <Datepicker
                onChange={handleDataFinal}
                isClearable={limpavel}
                selectedDate={
                  parametros.dataFinal.length > 0
                    ? new Date(parametros.dataFinal)
                    : undefined
                }
                placeholderText="Data final"
                dateFormat="dd/MM/yyyy"
                onBlur={event => {
                  const date = formatDate(event.target.value);
                  if (date) {
                    handleDataFinal(parseDate(date, 'dd/MM/yyyy'));
                  }
                }}
              />
            </HStack>
          </FormControl>
        </HStack>
        <Button
          type="button"
          color="white"
          background="gray.900"
          _hover={{
            bgColor: 'black',
          }}
          onClick={() => novoPolitica()}
        >
          Nova atualização
        </Button>
      </HStack>
      <Table type="custom">
        <Thead>
          <Tr>
            <Th>DESCRIÇÃO</Th>
            <Th>
              <Flex
                gap={2}
                cursor="pointer"
                onClick={() => {
                  const order = queryParams.get('order');
                  const dataInicial = queryParams.get('dataInicial');
                  const dataFinal = queryParams.get('dataFinal');
                  setParametros({
                    ...parametros,
                    order: order === 'ASC' ? 'DESC' : 'ASC',
                    orderBy: 'data_criacao',
                    pagina: queryParams.get('pagina') ?? '1',
                  });
                  updateUrlParams(
                    {
                      ...parametros,
                      order: order === 'ASC' ? 'DESC' : 'ASC',
                      orderBy: 'data_criacao',
                      pagina: queryParams.get('pagina') ?? '1',
                      dataInicial: dataInicial ?? '',
                      dataFinal: dataFinal ?? '',
                    },
                    history,
                  );
                }}
              >
                DATA DE CRIAÇÃO{' '}
                {parametros.order === 'ASC' &&
                parametros.orderBy === 'data_criacao' ? (
                  <ChevronDownIcon fontSize={14} ml="2" />
                ) : (
                  <ChevronUpIcon fontSize={14} ml="2" />
                )}
              </Flex>
            </Th>
            <Th>
              <Flex
                gap={2}
                cursor="pointer"
                onClick={() => {
                  const order = queryParams.get('order');
                  const dataInicial = queryParams.get('dataInicial');
                  const dataFinal = queryParams.get('dataFinal');
                  setParametros({
                    ...parametros,
                    order: order === 'ASC' ? 'DESC' : 'ASC',
                    orderBy: 'data_publicacao',
                    pagina: queryParams.get('pagina') ?? '1',
                  });
                  updateUrlParams(
                    {
                      ...parametros,
                      order: order === 'ASC' ? 'DESC' : 'ASC',
                      orderBy: 'data_publicacao',
                      pagina: queryParams.get('pagina') ?? '1',
                      dataInicial: dataInicial ?? '',
                      dataFinal: dataFinal ?? '',
                    },
                    history,
                  );
                }}
              >
                DATA DE PUBLICAÇÃO{' '}
                {parametros.order === 'ASC' &&
                parametros.orderBy === 'data_publicacao' ? (
                  <ChevronDownIcon fontSize={14} ml="2" />
                ) : (
                  <ChevronUpIcon fontSize={14} ml="2" />
                )}
              </Flex>
            </Th>
            <Th textAlign="center">SITUAÇÃO</Th>
            <Th textAlign="center">AÇÕES</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data?.results.length ? (
            data?.results.map(msg => (
              <Tr key={msg.id}>
                <Td maxW="200px" verticalAlign="top">
                  <Text
                    overflowX="hidden"
                    textOverflow="ellipsis"
                    whiteSpace="nowrap"
                    title={msg.descricao}
                  >
                    {msg.descricao}
                  </Text>
                </Td>
                <Td verticalAlign="top">{msg.formattedCriacao}</Td>
                <Td verticalAlign="top">{msg.formattedPublicacao}</Td>
                <Td textAlign="center" verticalAlign="top">
                  <StatusBadge variant={msg.statusColor}>
                    {msg.formattedStatus}
                  </StatusBadge>
                </Td>
                <Td verticalAlign="top">
                  <HStack gridGap={2} justifyContent="center">
                    {msg.status === AnnouncementsStatus.RASCUNHO ? (
                      <>
                        <Tooltip
                          hasArrow
                          label="Editar"
                          bg="black"
                          shouldWrapChildren
                        >
                          <IconButton
                            isDisabled={isFetching}
                            aria-label="Editar"
                            onClick={() => editarPolitica(msg.id!)}
                            icon={<Icon as={FaEdit} />}
                          />
                        </Tooltip>
                        <Tooltip
                          hasArrow
                          label="Publicar"
                          bg="black"
                          shouldWrapChildren
                        >
                          <IconButton
                            isDisabled={isFetching}
                            onClick={() => {
                              setIdSelecionado(msg.id!);
                              onOpenModalPublicar();
                            }}
                            aria-label="Publicar"
                            icon={<Icon as={FaCloudUploadAlt} />}
                          />
                        </Tooltip>
                      </>
                    ) : (
                      <>
                        <Tooltip
                          hasArrow
                          label="Visualizar"
                          bg="black"
                          shouldWrapChildren
                        >
                          <IconButton
                            isDisabled={isFetching}
                            aria-label="Visualizar"
                            onClick={() => visualizarPolitica(msg.id!)}
                            icon={<Icon as={FaEye} />}
                          />
                        </Tooltip>
                        <Tooltip
                          hasArrow
                          label="Relatório"
                          bg="black"
                          shouldWrapChildren
                        >
                          <IconButton
                            aria-label="Relatório"
                            onClick={() => relatorioPolitica(msg.id!)}
                            icon={<Icon as={FaFileDownload} />}
                          />
                        </Tooltip>
                      </>
                    )}
                  </HStack>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td textAlign="center" colSpan={6}>
                {isLoading ? <Spinner /> : 'Não há dados a serem apresentados'}
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>
      <Flex justify="flex-end">
        {data && (
          <Pagination
            totalCountOfRegisters={data.count}
            currentPage={Number(parametros.pagina) ?? 1}
            onPageChange={_page => {
              const dataInicial = queryParams.get('dataInicial');
              const dataFinal = queryParams.get('dataFinal');
              setParametros({ ...parametros, pagina: _page.toString() });
              updateUrlParams(
                {
                  ...parametros,
                  pagina: _page.toString(),
                  dataInicial: dataInicial ?? '',
                  dataFinal: dataFinal ?? '',
                },
                history,
              );
            }}
            onPageSizeChange={handlePageSizeChange}
            registersPerPage={Number(parametros.paginacao) ?? PAGE_SIZE}
          />
        )}
      </Flex>
      <ConfirmationDialog
        confirmar={() => publicarPolitica(idSelecionado!)}
        onClose={onCloseModalPublicar}
        isOpen={isOpenModalPublicar}
        titulo="Publicar atualização"
        btnConfirmText="Publicar"
        isDisabled={isFetching}
      >
        <span>
          Tem certeza que deseja publicar essa atualização? Ao confirmar, esta
          ação não poderá ser desfeita.
        </span>
      </ConfirmationDialog>
    </Box>
  );
};
